$(document).ready(function() {
    $(document).on('click', '.product-media-container', function() {
      $('.main-product-popup').addClass('active');
      $('.product-model-overlay').addClass('popup-active');
      $('.loading__spinner').addClass('hidden')
      $('body').css('overflow-y', 'hidden');
    });

    $(document).on('click', '.popup-close', function() {
      $('.main-product-popup').removeClass('active');
      $('.product-model-overlay').removeClass('popup-active');
      $('body').css('overflow-y', 'scroll');
  });


      $(document).mouseup(function (e) {
    var container = $('.product-popup-wrapper');
    if (!container.is(e.target) && container.has(e.target).length === 0 && $('.main-product-popup').hasClass('active')) {
      $('.main-product-popup').removeClass('active');
      $('.product-model-overlay').removeClass('popup-active');
      $('body').css('overflow-y', 'scroll');
    }
  });
  
    $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section').addClass('grid-view-section');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section').addClass('list-view-section');
    });

    var scrollDown = $('.read-more'),
    page = $('html, body'),
    slide = $('.product-description-section'),
    viewportHeight = $(window).height();
    
    $(function() {
    windowResize();
    });
    
    $(scrollDown).click(function(event) {
    var currentSlideHeight = $(this).parent().height();
    var halfSlideHeight = currentSlideHeight + 200; // Calculate half of section height
    // console.log("Current Slide Height:", currentSlideHeight);
    // console.log("Half Slide Height:", halfSlideHeight);
    page.animate({
        scrollTop: page.scrollTop() + halfSlideHeight, // Scroll down by half of section height
    }, 600);
    event.preventDefault();
    });
    
    function windowResize() {
    $(window).resize(function(e) {
        viewportHeight = $(window).height();
    });
    }
});


// $(document).ready(function(){
//    $('.read-more').click(function(){
//       console.log("hdfth");
//    });
// });